import mergeWith from 'lodash/mergeWith'
import merge from 'lodash/merge'

import isNumber from 'lodash/isNumber'
import cloneDeep from 'lodash/cloneDeep'

import { getMaxPossibleQuantity } from '@/checkout-instore-legacy/cart/message/utils'
import {
  CartMessageType,
  CartItemMessage,
} from '@/checkout-instore-legacy/cart/message/types'

interface BlockProductProperties {
  numeric: {
    enable: boolean
    show: boolean
    maxValue: number
    minValue: number
  }
  options: {
    changeSla: boolean
    switchSeller: boolean
    removeItem: boolean
  }
  footer: {
    show: boolean
  }
}

export const blockProductInitialState: BlockProductProperties = {
  numeric: {
    enable: true,
    show: true,
    maxValue: Infinity,
    minValue: 1,
  },
  options: {
    changeSla: true,
    switchSeller: true,
    removeItem: true,
  },
  footer: {
    show: true,
  },
}

const CART_PENDENCY_TYPE = {
  numeric: {
    enable: false,
    show: true,
    maxValue: Infinity,
    minValue: 1,
  },
  options: {
    changeSla: false,
    switchSeller: false,
    removeItem: true,
  },
  footer: {
    show: true,
  },
}

const CART_WARNING_TYPE = {
  numeric: {
    enable: true,
    show: true,
    maxValue: Infinity,
    minValue: 1,
  },
  options: {
    changeSla: true,
    switchSeller: true,
    removeItem: true,
  },
  footer: {
    show: true,
  },
}

const possibleBlockStates: Record<string, BlockProductProperties> = {
  [CartMessageType.ITEM_NOT_AVAILABLE]: CART_WARNING_TYPE,
  [CartMessageType.GENERIC_CART_ITEM_ERROR]: {
    ...CART_WARNING_TYPE,
    footer: {
      show: false,
    },
  },
  [CartMessageType.WITHOUT_PRICE]: CART_PENDENCY_TYPE,
  [CartMessageType.WITHOUT_STOCK]: CART_PENDENCY_TYPE,
}

export const getBlockProductProperties = (cartMessages: CartItemMessage[]) => {
  const getBlockerByMessageType = (
    message: CartItemMessage
  ): BlockProductProperties => {
    switch (message.type) {
      case CartMessageType.ITEM_NOT_AVAILABLE:
        return {
          ...possibleBlockStates[message.type],
          numeric: {
            ...possibleBlockStates[message.type].numeric,
            maxValue: getMaxPossibleQuantity(message).quantity,
            minValue: 1,
          },
        }
      default:
        return possibleBlockStates[message.type]
    }
  }

  const mergeCustomize = (
    objValue: boolean | number,
    srcValue: boolean | number
  ) => {
    if (isNumber(objValue) && srcValue !== Infinity) {
      if (objValue === Infinity) {
        return srcValue
      }
      return Math.max(objValue, srcValue as number)
    }
    return merge(objValue, srcValue)
  }

  const blockers = cartMessages
    .map((message) => getBlockerByMessageType(message))
    .reduce(
      (acc, value) => mergeWith(acc, value, mergeCustomize),
      cloneDeep(blockProductInitialState)
    )

  return blockers
}
